/* Jonelia Health 2026 – responsive Bildauslieferung & Kartengrößen */
(function(){
  'use strict';
  if(window.JoneliaImageQA26)return;
  window.JoneliaImageQA26=true;

  var sceneSelector='.jon26-performance__background,.jon-sparen__visual-img,.jon-account__scene';
  var productSelector='.product-item__image-wrapper img';

  function sized(url,width){
    try{
      var u=new URL(url,location.origin);
      if(u.hostname.indexOf('cdn.shopify.com')===-1)return '';
      u.searchParams.set('width',String(width));
      return u.toString();
    }catch(e){return '';}
  }

  function optimizeScene(img){
    if(!img||img.dataset.jonImageQa==='scene')return;
    var raw=img.getAttribute('src')||'';
    if(!raw)return;
    var u640=sized(raw,640),u960=sized(raw,960),u1280=sized(raw,1280),u1600=sized(raw,1600);
    if(!u1600)return;
    img.dataset.jonImageQa='scene';
    img.setAttribute('decoding','async');
    if(img.getAttribute('loading')==='lazy')img.setAttribute('fetchpriority','low');
    img.setAttribute('srcset',u640+' 640w, '+u960+' 960w, '+u1280+' 1280w, '+u1600+' 1600w');
    img.setAttribute('sizes','(max-width: 749px) 100vw, (max-width: 1599px) 92vw, 1500px');
    img.setAttribute('src',u1600);
  }

  function optimizeProduct(img){
    if(!img||img.dataset.jonProductSize==='1')return;
    var card=img.closest('.product-item');
    if(!card)return;
    var sizes='(max-width: 749px) 74vw, (max-width: 999px) 42vw, (max-width: 1499px) 240px, 250px';
    if(img.closest('.product-list--collection')){
      sizes='(max-width: 749px) 46vw, (max-width: 999px) 46vw, (max-width: 1279px) 30vw, (max-width: 1699px) 23vw, 18vw';
    }else if(img.closest('.jon-transition26__products')){
      sizes='(max-width: 749px) 64vw, 170px';
    }
    img.dataset.jonProductSize='1';
    img.setAttribute('sizes',sizes);
    img.setAttribute('decoding','async');
    if(img.getAttribute('loading')==='lazy')img.setAttribute('fetchpriority','low');
  }

  function scan(root){
    if(!root)return;
    if(root.matches){
      if(root.matches(sceneSelector))optimizeScene(root);
      if(root.matches(productSelector))optimizeProduct(root);
    }
    if(root.querySelectorAll){
      root.querySelectorAll(sceneSelector).forEach(optimizeScene);
      root.querySelectorAll(productSelector).forEach(optimizeProduct);
    }
  }

  scan(document);
  var mo=new MutationObserver(function(list){list.forEach(function(m){m.addedNodes.forEach(function(n){if(n.nodeType===1)scan(n);});});});
  mo.observe(document.documentElement,{childList:true,subtree:true});
})();
